import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ children, adminOnly = false }) {
    const { user } = useAuth();
    if (user === null) {
        return (
            <div className="min-h-[60vh] flex items-center justify-center text-[#a3a3a3] text-sm tracking-widest uppercase">
                Verifying session…
            </div>
        );
    }
    if (user === false) return <Navigate to="/login" replace />;
    if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
    return children;
}
